import { Component, OnInit } from '@angular/core';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
    selector: 'amd-print-button',
    templateUrl: './print-button.component.html',
    styleUrls: ['./print-button.component.scss']
})
export class PrintButtonComponent implements OnInit {

	translateContext = TranslateContext;

    constructor() { }

    ngOnInit() {
    }

    openPrintModal() {
        window.print();
    }

}
